import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { numberWithCommas } from "../../lib/Common";
const useStyles = makeStyles((theme) => ({
  pointDiv: {
    fontSize: "1.25rem",
    color: "red",
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: 15,
    paddingBottom: 10,
    textAlign: "center",
    height: "8%",
    "@media (min-width:600px)": {
      fontSize: "1.75rem",
    },
    // ["@media (min-width:600px)"]: {
    //   // eslint-disable-line no-useless-computed-key
    //   fontSize: "1.75rem",
    // },
  },
  noteDiv: {
    fontSize: "0.75rem",
    marginLeft: "auto",
    marginRight: "auto",
    color: "black",
    paddingTop: 10,
    textIndent: 50,
    "@media (min-width:600px)": {
      fontSize: "1.25rem",
      textIndent: 0,
    },
  },
  dateDiv: {
    fontSize: "0.75rem",
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: 5,
    paddingBottom: 5,
    color: "black",
    textAlign: "center",
    height: "8%",
    "@media (min-width:600px)": {
      fontSize: "1.25rem",
    },
  },
}));
function AvailablePoint(props) {
  const classes = useStyles();
  const { start_date, end_date, available_amt } = props.data;
  return (
    <Fragment>
      <div className={classes.pointDiv}>
        현재 잔여 포인트 :　{numberWithCommas(available_amt)}점
      </div>
      <div className={classes.noteDiv}>*2만점이상 사용 가능</div>
      <div className={classes.noteDiv}>
        *당일 적립 포인트는 익일부터 사용 가능
      </div>

      <div className={classes.dateDiv}>
        최근 24개월간의 내역입니다. <br />({start_date} ~ {end_date})
      </div>
    </Fragment>
  );
}

AvailablePoint.propTypes = {
  data: PropTypes.shape({
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    available_amt: PropTypes.string,
  }),
};

export default AvailablePoint;
